import request from '@/utils/request'

// 查询用户额外信息详细
export function getUserExtra(id) {
  return request({
    url: '/user/user/extra/' + id,
    method: 'get'
  })
}

// 新增用户额外信息
export function addUserExtra(data) {
  return request({
    url: '/user/user/extra',
    method: 'post',
    data: data
  })
}

// 修改用户额外信息
export function updateUserExtra(data) {
  return request({
    url: '/user/user/extra',
    method: 'put',
    data: data
  })
}

// 删除用户额外信息
export function delUserExtra(id) {
  return request({
    url: '/user/user/extra/' + id,
    method: 'delete'
  })
}
